// L'état vide : ce qu'on montre quand il n'y a rien à montrer.
//
// Un écran vide sans explication laisse croire à une panne. Celui-ci dit
// toujours pourquoi c'est vide, et si possible quoi faire.

export default function Vide({ symbole, titre, texte = "" }) {
  return (
    <div className="vide">
      <div className="vide__icone">{symbole}</div>
      <h3>{titre}</h3>
      {texte && <p>{texte}</p>}
    </div>
  );
}

/** « On cherche encore » — à ne montrer que si l'attente est réelle. */
export function Chargement({ texte = "Chargement…" }) {
  return (
    <div className="vide">
      <div className="spinner" />
      <p>{texte}</p>
    </div>
  );
}
